import { NavigationGuardNext, Route } from 'vue-router'
import multiGuard from '@/router/utils/vue-router-multiguard'
import checkTokenGuard from '@/router/guards/check-token-guard'
import authGuard from '@/router/guards/auth-guard'

export default [
  {
    path: '/error-unimplemented',
    name: 'error-unimplemented',
    component: () => import(/* webpackChunkName: "error-routes" */ '@/views/error/ErrorUnimplemented.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/error-404',
    name: 'error-404',
    component: () => import(/* webpackChunkName: "error-routes" */ '@/views/error/Error404.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/unauthorized',
    name: 'unauthorized',
    beforeEnter: multiGuard([checkTokenGuard, authGuard]),
    component: () => import(/* webpackChunkName: "error-routes" */ '@/views/error/Unauthorized.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/coming-soon',
    name: 'coming-soon',
    beforeEnter: (to: Route, from: Route, next: NavigationGuardNext) => {
      if (!to.query.access_token && to.query.from !== 'tablet' && to.path !== '/admin/menu') {
        return next('/')
      }
      return next()
    },
    component: () => import(/* webpackChunkName: "error-routes" */ '@/views/error/ComingSoonView.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '*',
    redirect: 'error-404',
  },
]
